export const THEMES = {
  dark: {
    label: 'Dark (Default)',
    vars: {
      '--bg':           '#0e1117',
      '--surface':      '#161b27',
      '--surface2':     '#1e2535',
      '--border':       '#2a3348',
      '--accent':       '#4ade80',
      '--accent2':      '#38bdf8',
      '--muted':        '#4b5675',
      '--text':         '#e2e8f0',
      '--text-dim':     '#8892aa',
      '--key':          '#93c5fd',
      '--str':          '#86efac',
      '--num':          '#fca5a5',
      '--bool':         '#f9a8d4',
      '--null':         '#94a3b8',
      '--idx':          '#fbbf24',
      '--error':        '#f87171',
      '--success-bg':   '#14532d',
      '--error-bg':     '#450a0a',
      '--error-border': '#7f1d1d',
    },
  },

  light: {
    label: 'Light',
    vars: {
      '--bg':           '#f8f9fc',
      '--surface':      '#ffffff',
      '--surface2':     '#f1f3f8',
      '--border':       '#d8dce8',
      '--accent':       '#16a34a',
      '--accent2':      '#0284c7',
      '--muted':        '#8b93a8',
      '--text':         '#1a2035',
      '--text-dim':     '#5a6380',
      '--key':          '#1d4ed8',
      '--str':          '#15803d',
      '--num':          '#b91c1c',
      '--bool':         '#9d174d',
      '--null':         '#64748b',
      '--idx':          '#b45309',
      '--error':        '#dc2626',
      '--success-bg':   '#dcfce7',
      '--error-bg':     '#fee2e2',
      '--error-border': '#fca5a5',
    },
  },

  monokai: {
    label: 'Monokai',
    vars: {
      '--bg':           '#1e1f1c',
      '--surface':      '#272822',
      '--surface2':     '#2f3129',
      '--border':       '#3e3d32',
      '--accent':       '#a6e22e',
      '--accent2':      '#66d9e8',
      '--muted':        '#75715e',
      '--text':         '#f8f8f2',
      '--text-dim':     '#999580',
      '--key':          '#66d9e8',
      '--str':          '#e6db74',
      '--num':          '#ae81ff',
      '--bool':         '#f92672',
      '--null':         '#75715e',
      '--idx':          '#fd971f',
      '--error':        '#f92672',
      '--success-bg':   '#1c2f0d',
      '--error-bg':     '#3b0a14',
      '--error-border': '#7d1427',
    },
  },

  nord: {
    label: 'Nord',
    vars: {
      '--bg':           '#242933',
      '--surface':      '#2e3440',
      '--surface2':     '#3b4252',
      '--border':       '#434c5e',
      '--accent':       '#a3be8c',
      '--accent2':      '#88c0d0',
      '--muted':        '#616e88',
      '--text':         '#eceff4',
      '--text-dim':     '#9099ab',
      '--key':          '#81a1c1',
      '--str':          '#a3be8c',
      '--num':          '#b48ead',
      '--bool':         '#ebcb8b',
      '--null':         '#616e88',
      '--idx':          '#d08770',
      '--error':        '#bf616a',
      '--success-bg':   '#1e2d1e',
      '--error-bg':     '#2d1e1e',
      '--error-border': '#6e3030',
    },
  },

  solarized: {
    label: 'Solarized Dark',
    vars: {
      '--bg':           '#001f27',
      '--surface':      '#002b36',
      '--surface2':     '#073642',
      '--border':       '#12505f',
      '--accent':       '#859900',
      '--accent2':      '#2aa198',
      '--muted':        '#586e75',
      '--text':         '#eee8d5',
      '--text-dim':     '#839496',
      '--key':          '#268bd2',
      '--str':          '#2aa198',
      '--num':          '#d33682',
      '--bool':         '#cb4b16',
      '--null':         '#586e75',
      '--idx':          '#b58900',
      '--error':        '#dc322f',
      '--success-bg':   '#0d2309',
      '--error-bg':     '#2d0a0a',
      '--error-border': '#6e1a1a',
    },
  },

  dracula: {
    label: 'Dracula',
    vars: {
      '--bg':           '#191a21',
      '--surface':      '#282a36',
      '--surface2':     '#323443',
      '--border':       '#44475a',
      '--accent':       '#50fa7b',
      '--accent2':      '#8be9fd',
      '--muted':        '#6272a4',
      '--text':         '#f8f8f2',
      '--text-dim':     '#8895c8',
      '--key':          '#8be9fd',
      '--str':          '#f1fa8c',
      '--num':          '#bd93f9',
      '--bool':         '#ff79c6',
      '--null':         '#6272a4',
      '--idx':          '#ffb86c',
      '--error':        '#ff5555',
      '--success-bg':   '#1a2e1d',
      '--error-bg':     '#2d1515',
      '--error-border': '#6e2222',
    },
  },
};

export const DEFAULT_THEME = 'dark';
const STORAGE_KEY = 'json-parser-theme';

export const ThemeManager = {
  /** Apply a theme by key, persisting the choice. */
  apply(themeKey) {
    const theme = THEMES[themeKey];
    if (!theme) return;

    const root = document.documentElement;
    for (const [prop, value] of Object.entries(theme.vars)) {
      root.style.setProperty(prop, value);
    }

    try { localStorage.setItem(STORAGE_KEY, themeKey); } catch { /* private browsing */ }
  },

  /** Load persisted theme or fall back to default. */
  restore() {
    let saved = DEFAULT_THEME;
    try { saved = localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME; } catch { /* ignore */ }
    if (!THEMES[saved]) saved = DEFAULT_THEME;
    ThemeManager.apply(saved);
    return saved;
  },
};
